import { CANONICAL_SSO_MESSAGES, IdentitySSOStage } from "./types";
import { IdentityLoading } from "./IdentityLoading";

export interface IdentitySSOStatusProps {
  stage: IdentitySSOStage;
}

export function IdentitySSOStatus({ stage }: IdentitySSOStatusProps) {
  const message = CANONICAL_SSO_MESSAGES[stage];
  if (stage === "complete") {
    return (
      <div className="sc-identity-sso" data-stage={stage} role="status" aria-live="polite">
        {message}
      </div>
    );
  }
  return (
    <div className="sc-identity-sso" data-stage={stage}>
      <IdentityLoading message={message} />
    </div>
  );
}
